import { RunStateTransition } from "types/generated";
import ExplainRunButton from "components/Run/elements/ExplainRunButton";

import DiscardedEntry from "../entries/DiscardedEntry";
import { RunEntryContext } from "../types";
import { getRunStateTransitionId } from "./getRunStateTransitionId";

export const createDiscardedEntry = (
  { timestamp, note, username, stateVersion }: RunStateTransition,
  { stackId, runId }: RunEntryContext
) => (
  <DiscardedEntry
    key={getRunStateTransitionId(timestamp, stateVersion)}
    timestamp={timestamp}
    note={note}
    username={username}
  >
    <ExplainRunButton stackId={stackId} runId={runId} />
  </DiscardedEntry>
);
